/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Ember from 'ember';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import Sprite from 'ember-animated/-private/sprite';
import { wait } from 'ember-animated';
import { AutoMergeOption } from 'cio/utils/components/self-serve-migration-modal';
import EnvironmentModel from 'cio/models/environment';

interface SelfServeMigrationModalIdToMultiIdMergeRulesArgs {
  environment: EnvironmentModel;
  mergeOption: AutoMergeOption;
  onChangeMergeOption: (value: AutoMergeOption) => unknown;
  onContinue: () => unknown;
  onBack: () => unknown;
}

const COLLAPSE_DURATION = 200;

export default class SelfServeMigrationModalIdToMultiIdMergeRules extends Component<SelfServeMigrationModalIdToMultiIdMergeRulesArgs> {
  readonly AutoMergeOption = AutoMergeOption;

  @tracked autoMergePanelExpanded = true;
  @tracked userCollapsedAutoMergePanel = false;

  get submitDisabled() {
    return this.args.mergeOption == null;
  }

  get willMerge() {
    return this.args.mergeOption != null && this.args.mergeOption !== AutoMergeOption.Manual;
  }

  constructor(
    owner: SelfServeMigrationModalIdToMultiIdMergeRules,
    args: SelfServeMigrationModalIdToMultiIdMergeRulesArgs,
  ) {
    super(owner, args);

    if (args.mergeOption === AutoMergeOption.Manual) {
      this.autoMergePanelExpanded = false;
    }
  }

  @action
  toggleAutoMergePanelExpansion() {
    this.autoMergePanelExpanded = !this.autoMergePanelExpanded;
    this.userCollapsedAutoMergePanel = true;
  }

  @action
  maybeCollapseOverview() {
    if (this.args.mergeOption === AutoMergeOption.Manual) {
      this.autoMergePanelExpanded = false;
    } else if (!this.userCollapsedAutoMergePanel) {
      this.autoMergePanelExpanded = true;
    }
  }

  readonly collapseTransitionDuration = COLLAPSE_DURATION;
  *collapseTransition({ removedSprites }: { removedSprites: Sprite[] }) {
    // This makes sure the disappearing panel body doesn't disappear instantly.
    // Otherwise the container will be empty while it animates, which we don't
    // want.
    // eslint-disable-next-line
    for (let _ of removedSprites) {
      if (!Ember.testing) {
        yield wait(COLLAPSE_DURATION);
      }
    }
  }
}
